export default "<app-product-category-list>Loading ...</app-product-category-list>\n"